import React, { useEffect, useState, useLayoutEffect } from 'react';
import Button from 'component/button.component';
import {
  InputLabel,
  FormControl,
  FormControlLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  FormHelperText,
} from '@material-ui/core';
import { fillSelects } from 'store/action/clippings.action';
import { TextField } from '@material-ui/core';
import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import templateRepository from 'repositories/templates';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import recordRepository from 'repositories/records';

export default function Template({ location, history }) {
  const defaultState = {
    id: '',
    template: '',
    template_name: '',
    action_id: '',
    actionSelect: [],
    status: 'ACTIVE',
    binary: false,
  };

  const [state, setState] = useState(defaultState);

  const tagButtons = [
    '<autor/>',
    '<autor-reu/>',
    '<reu/>',
    '<reu-autor/>',
    '<advogado/>',
    '<oab-numero/>',
    '<oab-sigla/>',
    '<processo/>',
    '<vara/>',
    '<data-extenso/>',
  ];

  useEffect(() => {
    async function fetchData() {
      const result = await templateRepository.fillTemplate(id);
      setState(result.data);
    }
    if (isEdition) {
      fetchData();
    }
    fillSelects('actions')
      .then(actions => {
        setState(prevState => ({
          ...prevState,
          actionSelect: actions.data,
        }));
      })
      .catch(err => {
        console.warn(err.message);
      });
  }, []);

  const onChangeText = content => {
    setState(prevState => ({
      ...prevState,
      template: content,
    }));
  };

  const handleChange = e => {
    const { name, value } = e.target;
    setState(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const onButtonUpdate = () => {
    if (state.template.match(/&lt;autor-reu\/&gt;|&lt;reu-autor\/&gt;/g)) {
      setState(prevState => ({
        ...prevState,
        binary: true,
      }));
    } else if (state.binary) {
      setState(prevState => ({
        ...prevState,
        binary: false,
      }));
    }
  };

  const copyToClipboard = content => {
    navigator.clipboard.writeText(content);
    toast.success(`Texto ${content} copiado.`);
  };

  const init = () => {
    const { actionSelect } = state;
    setState(defaultState);
    setState(prevState => ({
      ...prevState,
      actionSelect,
    }));
  };

  const insertTemplate = () => {
    templateRepository.addTemplate(state).then(() => {
      init();
      history.push(`/admin/template`);
      toast.success('Template criado com sucesso!');
    });
  };

  const modifyTemplate = () => {
    templateRepository.updateTemplate(id, state).then(() => {
      init();
      history.push(`/admin/template`);
      toast.success('Template atualizado com sucesso!');
    });
  };

  const templateDownload = () => {
    recordRepository.templateDownload({
      title: state.template_name,
      text: state.template,
    });
  };

  const [, , , edit, id] = location.pathname.split('/');
  const isEdition = Boolean(edit === 'edicao');

  const templateRegister = Yup.object().shape({
    template: Yup.string().required('Texto do template é necessário'),
    template_name: Yup.string().required('Título do template é necessário'),
    action_id: Yup.number().required('Ação necessária'),
  });

  return (
    <Formik
      enableReinitialize={true}
      initialValues={state}
      validationSchema={templateRegister}
    >
      {({ errors, touched, validateForm, setTouched }) => (
        <div>
          <h3 align="center" style={{ paddingTop: 8, fontWeight: 'bold' }}>
            Inserir Templates
          </h3>
          <div className="flex-row align-stretch justify-center self-align-center">
            {tagButtons.map((content, i) => (
              <Button
                onClick={() => copyToClipboard(content)}
                key={i}
                text={content}
                style={{
                  margin: 10,
                  backgroundColor: '#333333',
                }}
              />
            ))}
          </div>
          <div className="flex-column align-stretch">
            <Form>
              <div className="flex-row align-stretch justify-center self-align-center">
                <div
                  className="flex-column"
                  style={{
                    marginBottom: '10px',
                    border: '1px solid rgba(164,164,164,0.3)',
                    borderRadius: '6px',
                    padding: '5px',
                    backgroundColor: '#ffffff',
                    width: 200,
                    textAlign: 'center',
                  }}
                >
                  <span style={{ fontWeight: 'bold' }}>Opções do Template</span>
                  {state.binary && (
                    <>
                      <Button
                        onClick={() => alert('reclamante')}
                        text="Reclamante"
                        style={{
                          marginLeft: 0,
                          marginTop: 10,
                          backgroundColor: '#185335',
                        }}
                      />
                      <Button
                        onClick={() => alert('reclamado')}
                        text="Reclamado"
                        style={{
                          marginLeft: 0,
                          marginTop: 10,
                          backgroundColor: '#185335',
                        }}
                      />
                    </>
                  )}
                </div>
                <div
                  style={{
                    margin: '0px 10px',
                    maxWidth: 700,
                    maxHeight: '70vh',
                    overflow: 'auto',
                  }}
                  className="flex-column"
                >
                  <FormControl
                    error={errors.template}
                    style={{ marginTop: 10 }}
                  >
                    <CKEditor
                      editor={ClassicEditor}
                      data={state.template}
                      onChange={(event, editor) => {
                        onChangeText(editor.getData());
                      }}
                    />
                    <FormHelperText error={errors.template}>
                      {errors.template && 'Texto do template necessário'}
                    </FormHelperText>
                  </FormControl>
                </div>
                <div
                  className="flex-column align-stretch"
                  style={{
                    marginBottom: '10px',
                    border: '1px solid rgba(164,164,164,0.3)',
                    borderRadius: '6px',
                    padding: '5px',
                    backgroundColor: '#ffffff',
                    textAlign: 'center',
                    width: 300,
                  }}
                >
                  <span style={{ fontWeight: 'bold' }}>
                    Descrição do Template
                  </span>
                  <FormControl
                    error={errors.action_id}
                    style={{ marginTop: 10 }}
                  >
                    <InputLabel htmlFor="action_id">Ação</InputLabel>
                    <Select
                      name="action_id"
                      value={state.action_id}
                      onChange={handleChange}
                    >
                      {state.actionSelect != undefined
                        ? state.actionSelect.map((a, i) => (
                            <MenuItem key={i} value={a.id}>
                              {a.action}
                            </MenuItem>
                          ))
                        : []}
                    </Select>
                    <FormHelperText error={errors.action_id}>
                      {errors.action_id && 'Ação necessária'}
                    </FormHelperText>
                  </FormControl>
                  <TextField
                    name="template_name"
                    label="Título do Template"
                    value={state.template_name}
                    onChange={handleChange}
                    style={{ marginTop: 10 }}
                    onBlur={handleChange}
                    error={errors.template_name && touched.template_name}
                    helperText={
                      errors.template_name &&
                      touched.template_name &&
                      errors.template_name
                    }
                  />
                  <FormControl component="fieldset" style={{ marginTop: 10 }}>
                    <RadioGroup
                      row
                      value={state.status}
                      aria-label="status"
                      name="status"
                      onChange={handleChange}
                      style={{ placeContent: 'center' }}
                    >
                      <FormControlLabel
                        control={<Radio color="primary" />}
                        value="ACTIVE"
                        label="Ativo"
                      />
                      <FormControlLabel
                        value="INACTIVE"
                        control={<Radio color="secondary" />}
                        label="Inativo"
                      />
                    </RadioGroup>
                  </FormControl>
                  <Button
                    onClick={onButtonUpdate}
                    text="Atualizar"
                    style={{
                      marginLeft: 0,
                      backgroundColor: '#185335',
                    }}
                  />
                  {isEdition ? (
                    <Button
                      onClick={() => {
                        validateForm().then(errors => {
                          if (
                            Object.entries(errors).length === 0 &&
                            errors.constructor === Object
                          ) {
                            modifyTemplate();
                          } else {
                            setTouched(errors);
                          }
                        });
                      }}
                      text="Alterar"
                      style={{
                        marginLeft: 0,
                        marginTop: 10,
                        backgroundColor: '#185335',
                      }}
                    />
                  ) : (
                    <Button
                      onClick={() => {
                        validateForm().then(errors => {
                          if (
                            Object.entries(errors).length === 0 &&
                            errors.constructor === Object
                          ) {
                            insertTemplate();
                          } else {
                            setTouched(errors);
                          }
                        });
                      }}
                      text="Gravar"
                      style={{
                        marginLeft: 0,
                        marginTop: 10,
                        backgroundColor: '#185335',
                      }}
                    />
                  )}
                  <Button
                    onClick={templateDownload}
                    text="Baixar Minuta"
                    style={{
                      marginLeft: 0,
                      marginTop: 10,
                      backgroundColor: '#185335',
                    }}
                  />
                </div>
              </div>
            </Form>
          </div>
        </div>
      )}
    </Formik>
  );
}
